import request from '../utils/request'

// 获取用户列表（分页+模糊查询）
export function getUserList(data) {
  return request({
    url: '/user/page',
    method: 'post',
    data
  })
}

// 根据ID获取用户详情
export function getUserById(id) {
  return request({
    url: `/user/${id}`,
    method: 'get'
  })
}

// 获取全部用户
export function getAllUsers() {
  return request({
    url: '/user/all',
    method: 'get'
  })
}

// 获取所有用户-部门关联
export function getAllUserDeptRelations() {
  return request({
    url: '/user/all-dept-relations',
    method: 'get'
  })
}

// 获取用户角色
export function getUserRoles(id) {
  return request({
    url: `/user/${id}/roles`,
    method: 'get'
  })
}

// 获取用户部门
export function getUserDepartments(id) {
  return request({
    url: `/user/${id}/departments`,
    method: 'get'
  })
}

// 创建用户
export function createUser(data) {
  return request({
    url: '/user',
    method: 'post',
    data
  })
}

// 更新用户
export function updateUser(data) {
  return request({
    url: '/user',
    method: 'put',
    data
  })
}

// 修改用户密码
export function updateUserPassword(data) {
  return request({
    url: '/user/password',
    method: 'put',
    data
  })
}

// 更新用户角色
export function updateUserRoles(data) {
  return request({
    url: '/user/roles',
    method: 'put',
    data
  })
}

// 更新用户部门
export function updateUserDepartments(data) {
  return request({
    url: '/user/departments',
    method: 'put',
    data
  })
}

// 更新用户关联员工（可解绑）
export function updateUserEmployee(data) {
  return request({
    url: '/user/employee',
    method: 'put',
    data
  })
}

// 删除用户
export function deleteUser(id) {
  return request({
    url: `/user/${id}`,
    method: 'delete'
  })
}

// 校验用户名是否存在
export function checkUsername(username) {
  return request({
    url: `/user/checkUsername/${username}`,
    method: 'get'
  })
}